import * as Yup from 'yup';
import _isEmpty from 'lodash/isEmpty';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    name: Yup.string().required(t('Name is required')),
    externalId: Yup.string().nullable(),
    openFromTimeLocal: Yup.string().nullable(),
    openToTimeLocal: Yup.string()
      .nullable()
      .when('openFromTimeLocal', {
        is: val => !_isEmpty(val),
        then: Yup.string()
          .required(t('Dock Closes is required'))
          .greaterThan(
            Yup.ref('openFromTimeLocal'),
            t('Dock Closes must be greater than Dock Opens')
          )
      }),
    address: Yup.object().shape({
      address1: Yup.string().required(t('Address Line 1 is required')),
      city: Yup.string().required(t('City is required')),
      postalCode: Yup.string()
        .zip(t('Zip code must be a valid zip code'))
        .required(t('Zip Code is required')),
      state: Yup.string().required(t('State is required')),
      country: Yup.string().required(t('Country is required'))
    })
  });

export default validationSchema;
